module.exports = __webpack_public_path__ + "media/images/v2/icon2-7dbc744ab871fa78ccb17a6657a1659e.png";